// THIS FILE WAS AUTOGENERATED BY SVGR. DO NOT MODIFY IT MANUALLY;
import { Ref, SVGProps, forwardRef, memo } from 'react'

const SvgLogoSlackOnDark = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M6.216 14.651c0 1.162-.938 2.1-2.1 2.1-1.161 0-2.1-.938-2.1-2.1 0-1.161.939-2.1 2.1-2.1h2.1v2.1Zm1.05 0c0-1.161.94-2.1 2.1-2.1 1.162 0 2.101.939 2.101 2.1v5.251c0 1.162-.939 2.1-2.1 2.1-1.162 0-2.1-.938-2.1-2.1v-5.25Z"
      fill="#E01E5A"
    />
    <path
      d="M9.367 6.219c-1.162 0-2.1-.94-2.1-2.1 0-1.162.938-2.1 2.1-2.1 1.161 0 2.1.938 2.1 2.1v2.1h-2.1Zm0 1.066c1.161 0 2.1.938 2.1 2.1 0 1.161-.939 2.1-2.1 2.1H4.1c-1.161 0-2.1-.939-2.1-2.1 0-1.162.939-2.1 2.1-2.1h5.267Z"
      fill="#36C5F0"
    />
    <path
      d="M17.784 9.385c0-1.162.938-2.1 2.1-2.1 1.161 0 2.1.938 2.1 2.1 0 1.161-.939 2.1-2.1 2.1h-2.1v-2.1Zm-1.05 0c0 1.161-.94 2.1-2.1 2.1-1.162 0-2.101-.939-2.101-2.1V4.118c0-1.161.939-2.1 2.1-2.1 1.162 0 2.1.939 2.1 2.1v5.267Z"
      fill="#2EB67D"
    />
    <path
      d="M14.633 17.802c1.162 0 2.1.939 2.1 2.1 0 1.162-.938 2.1-2.1 2.1-1.161 0-2.1-.938-2.1-2.1v-2.1h2.1Zm0-1.05c-1.161 0-2.1-.94-2.1-2.1 0-1.162.939-2.1 2.1-2.1H19.9c1.161 0 2.1.938 2.1 2.1 0 1.16-.939 2.1-2.1 2.1h-5.267Z"
      fill="#ECB22E"
    />
  </svg>
))
SvgLogoSlackOnDark.displayName = 'SvgLogoSlackOnDark'
const Memo = memo(SvgLogoSlackOnDark)
export { Memo as SvgLogoSlackOnDark }
